'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
function validatePostalCode(postalCode, countryCode) {
	var valid = false;
	var re = null;
	var country = String(countryCode).toLowerCase() || 'can';

	if (postalCode) {
		if (country === 'usa') {
			re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
			valid = re.test(String(postalCode).toLowerCase());
		} else {
			re = /[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]/i;
			valid = re.test(String(postalCode).toLowerCase());
		}
	}

	return valid;
}

exports.default = validatePostalCode;